export default {
    data() {
        return {
            keyword: '',
            createDateFrom: '',
            createDateTo: '',
            revenueFrom: '',
            revenueTo: '',
            expenseFrom: '',
            expenseTo: ''
        };
    }
}